
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name core.controller:cardSign
     *
     * @description
     *
     */
    angular
        .module('core')
        .directive('cardSign', cardSign);

    function cardSign(CardsService, HelperService, $state, NotificationService) {
        return {
            restrict: 'E',
            scope: {
                request: '=',
                card: '=',
                title: '@'
            },
            templateUrl: 'cards/shared/card-sign/card-sign.tpl.html',
            replace: false,
            controllerAs: 'vm',
            controller: function ($scope) {
                HelperService.loadChallengeResponse($scope.card, $scope);
                HelperService.initializeMTokenSignature.call($scope, $scope, function () {
                    updateCardStatus();
                }, function () {
                    goToCard();
                });

                function goToCard() {
                    $state.go('card', {
                        cardId: $scope.card.cardId
                    });
                }

                function updateCardStatus() {
                    $scope.request.signData = $scope.challengeResponse;
                    if ($scope.challengeResponse2) {
                        $scope.request.additionalSignData = $scope.challengeResponse2;
                    }
                    CardsService.updateCard($scope.request, $scope.card.cardId).then(function (data) {
                        $scope.card = data;
                        goToCard();
                    }).catch(function(error) {
                        NotificationService.showMessage(error, 'error')
                        $scope.signInProgress = false;
                    });
                }


            }
        };
    }
}());